module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<h4 class=\"list__body__item__details__header\">")
    ; __append(escapeFn( locals.mainHeading ))
    ; __append("</h4> ")
    ;  if(!locals.fetch) { 
    ; __append(" <div class=\"row\"> <div class=\"col-8 list__body__item__details__body\"> <pre class=\"highlight\"><code>")
    ; __append( locals.formattedJSON )
    ; __append("</code></pre> </div> <div class=\"col-4 list__body__item__details__sidebar\"> ")
    ;  locals.detailBlocks.forEach(function(detailBlock) { 
    ; __append(" ")
    ;  if (detailBlock.heading) { 
    ; __append(" <h4 class=\"list__body__item__details__subheading\">")
    ; __append(escapeFn( detailBlock.heading ))
    ; __append("</h4> ")
    ;  } 
    ; __append(" <div class=\"")
    ; __append(escapeFn( detailBlock.wrapperSubClass ? 'list__body__item__details__' + detailBlock.wrapperSubClass : ''  ))
    ; __append("\"> ")
    ;  detailBlock.subViews.forEach(function(subView, idx) { 
    ; __append(" <div id=\"")
    ; __append(escapeFn( locals.computeDetailsBlockId(locals.model.get('id'), detailBlock.uid, idx) ))
    ; __append("\"></div> ")
    ;  }); 
    ; __append(" <p> ")
    ;  if (typeof detailBlock.items === 'function') { 
    ; __append(" ")
    ;  detailBlock.items(locals.model).forEach(function(item, idx) { 
    ; __append(" ")
    ;  if (item && item.href)  { 
    ; __append(" <a href=\"")
    ; __append(escapeFn( item.href ))
    ; __append("\">")
    ; __append(escapeFn( item.text ))
    ; __append("</a> ")
    ;  } else { 
    ; __append(" ")
    ; __append(escapeFn( item ))
    ; __append(" ")
    ;  } 
    ; __append(" ")
    ;  if (locals.detailBlocks.length !== idx) { 
    ; __append(" <br> ")
    ;  } 
    ; __append(" ")
    ;  }); 
    ; __append(" ")
    ;  } 
    ; __append(" </p> </div> ")
    ;  }); 
    ; __append(" </div> </div> ")
    ;  } 
    ; __append(" ")
    ;  if(locals.fetch) { 
    ; __append(" <div id=\"loader\" class=\"loader\"></div> ")
    ;  } 
    ; __append(" ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/list/object_details/template.ejs
// module id = 1238
// module chunks = 1